import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles((theme) => ({
    inputRoot: {
        padding: `${theme.px2rem(8)} ${theme.px2rem(16)}`,
    },
    orgDataValue: {
        fontSize: theme.px2rem(12),
    },
}));
